(function(){
    'use strict'; 
    angular.module('Directives').directive('bbaTabsPane', bbaTabsPane);
    
    function bbaTabsPane() {
        return {
            require: '^bbaTabs',
            restrict: 'E',
            scope: {title: '@'},
            link: bbaTabsPaneLink,
            transclude: true,
            template: `<div ng-show="selected" ng-transclude></div>`
        }

        function bbaTabsPaneLink(scope, elements, attrs, tabsCtrl) {
            init();

            function init() {
                tabsCtrl.addPane(scope);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-tabs/bba-tabs-pane.js